"use strict";

var _toConsumableArray = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var address_1 = require("../address");

var helpers_1 = require("../helpers");

var hex_1 = require("../hex");

var sharedHelpers_1 = require("./sharedHelpers");

function detectArgType(arg) {
  var noArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var result = null;

  if (!helpers_1.isEmpty(arg)) {
    switch (typeof arg) {
      case 'boolean':
        result = 'bool';
        break;

      case 'string':
        if (hex_1.isHex(arg, 'data')) {
          result = 'bytes';
        } else if (hex_1.isHex(arg, 'quantity')) {
          result = 'uint256';
        } else {
          result = 'string';
        }

        break;

      case 'number':
        result = 'uint256';
        break;

      case 'object':
        if (Array.isArray(arg) && !noArray) {
          if (arg.length === 0) {
            result = 'any[]';
          } else {
            result = detectArgType(arg[0]);

            if (result) {
              for (var i = 1; i < arg.length; i += 1) {
                var type = detectArgType(arg[i], true);

                if (!type || type !== result) {
                  result = null;
                }
              }

              if (result) {
                result = "".concat(result, "[]");
              }
            }
          }
        } else if (bn_js_1.default.isBN(arg)) {
          result = 'uint256';
        } else if (Buffer.isBuffer(arg)) {
          result = 'bytes';
        }

        break;
    }
  }

  return result;
}

exports.detectArgType = detectArgType;

function encodeNonArrayArg(mainType, value) {
  var padBytes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var result = null;

  if (mainType === 'uint') {
    mainType = 'uint256';
  }

  switch (mainType) {
    case 'address':
      if (!address_1.isAddress(value)) {
        throw new Error('invalid address');
      }

      result = value.toLowerCase();
      break;

    case 'bool':
    case 'bytes':
    case 'string':
      result = hex_1.toHex(value);
      break;

    default:
      var _sharedHelpers_1$pars = sharedHelpers_1.parseType(mainType),
          type = _sharedHelpers_1$pars.type,
          bytes = _sharedHelpers_1$pars.bytes;

      if (bytes > 0) {
        switch (type) {
          case 'bytes':
            if (padBytes) {
              result = hex_1.padHexRight(value, bytes);
            } else {
              result = value;
            }

            break;

          case 'uint':
            result = hex_1.padHexLeft(value, bytes);
            break;
        }
      }

  }

  return result;
}

function encodeArg(arg, packed) {
  var result = null;
  var type = arg.type,
      value = arg.value;
  var innerType = null;

  if (type.endsWith('[]')) {
    innerType = type.slice(0, -2);

    switch (innerType) {
      case 'bytes':
      case 'string':
        throw new Error("".concat(type, " not supported"));
    }

    if (!Array.isArray(value)) {
      throw new Error('expected array value');
    }

    var encoded = value.map(function (innerValue) {
      return encodeNonArrayArg(innerType, innerValue, true);
    });

    if (packed) {
      result = hex_1.concatHex.apply(hex_1, _toConsumableArray(encoded));
    } else {
      result = hex_1.concatHex(hex_1.padHexLeft(hex_1.toHex(value.length), 32), hex_1.concatHex.apply(hex_1, _toConsumableArray(encoded.map(function (value) {
        return hex_1.padHexLeft(value, 32);
      }))));
    }
  } else {
    result = encodeNonArrayArg(type, value, !packed);

    if (result && !packed) {
      switch (type) {
        case 'bytes':
        case 'string':
          result = hex_1.concatHex(hex_1.padHexLeft(hex_1.getHexBytesSize(result), 32), hex_1.padHexRight(result, 32));
          break;

        default:
          result = hex_1.padHex(result, 32, type.startsWith('bytes') ? 'right' : 'left');
      }
    }
  }

  return result;
}

exports.encodeArg = encodeArg;